import { useEffect, ReactNode } from "react";
import "./snackbarUi.scss";

import toast, { ISnackbarOption } from "@src/utils/toast";
import { logEvent } from "@src/reactGa";

import { Icon } from "@src/shared/src";

import CloseIcon from "@src/assets/images/icon/ic_stylehate_nor_24_white.png";

export default function SnackbarUi(
  props: ISnackbarOption & {
    id?: number | string;
    message: string | ReactNode;
  },
) {
  const {
    id,
    message,
    type,
    isShowClose,
    icon,
    position,
    bottomPosition,
    textAlign,
    removeTime,
    isAutoRemove,
    buttonText,
    onClick,
  } = props;

  // snackbar ui에서는 xPosition 사용하지 않음
  // const xPosition = position?.[0];
  const yPosition = position?.[1];

  const inlineStyle = {};
  if (textAlign) {
    inlineStyle["text-align"] = textAlign;
  }
  if (bottomPosition) {
    inlineStyle["bottom"] = bottomPosition;
  }

  // 자동삭제
  // id 필수, isAutoRemove는 true가 기본값, removeTime은 5000ms가 기본값
  useEffect(() => {
    if (id === undefined || isAutoRemove === false) return;

    const _removeTime = removeTime || 5000;
    const timeout = setTimeout(() => toast.removeSnackbar(id), _removeTime);

    return () => {
      clearTimeout(timeout);
    };
    // eslint-disable-next-line
  }, [id, isAutoRemove]);

  function handleClickSnackbar() {
    if (onClick === undefined) return;

    // GA 처리
    logEvent("notice", {
      component: "snackbar",
      behavior: "click",
      title: message,
      page_path: window.location.pathname,
    });

    onClick();
  }

  function handleClickClose(id: number | string) {
    toast.removeSnackbar(id);
  }

  return (
    <div
      className={`
        snackbar-ui-component-container
        ${position ? "fade-in-animation" : "slide-up-animation"}
        ${yPosition ? `snackbar-ui-y-position-${yPosition}` : ""}
        ${type === "error" ? "snackbar-error" : "snackbar-default"}
      `}
      style={inlineStyle}
    >
      <div className="snackbar-ui-component">
        {icon && (
          <div className="snackbar-ui-component-icon">
            <Icon name={icon.name} size={icon.size || 18} />
          </div>
        )}
        {typeof message === "string" ? <p className="snackbar-ui-component-message">{message}</p> : message}

        {buttonText !== undefined && (
          <button className="btn snackbar-ui-component-button" onClick={handleClickSnackbar}>
            {buttonText}
          </button>
        )}

        {isShowClose === true && id !== undefined && (
          <button
            onClick={() => handleClickClose(id)}
            className="btn btn-icon snackbar-ui-component-close-btn"
          >
            <img src={CloseIcon} alt="닫기" />
          </button>
        )}
      </div>
    </div>
  );
}
